module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJ1BMVEX////M09PLz9fJz9XKzdXLztTJzdXKztTJzdTJzdTJzdTJzdTJzdRz//6pAAAADHRSTlMCI0BVVliAgYnz9PvGgocIAAAAAWJLR0QAiAUdSAAAADFJREFUGNNjYKAGYETmaDUgcaKPI3GY9yBLWZ8gTsr7GILNsieBCAkUSzUTcDmUEgAAmHMMYJYhJrwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-arrow.png
// module id = D0E3
// module chunks = 1